import React, { useState } from 'react';
import axios from 'axios';

// --- SUBCOMPONENTE ---
const LinhaProduto = ({ prod, provider, onStatusChange }) => {
    const [vinculado, setVinculado] = useState(prod.vinculado);
    const [localId, setLocalId] = useState(prod.local_id || '');

    const [termoBusca, setTermoBusca] = useState('');
    const [resultadosBusca, setResultadosBusca] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [desfazendo, setDesfazendo] = useState(false);

    const buscarNoSistema = async (e) => {
        e.preventDefault();
        if (!termoBusca || termoBusca.length < 1) return;

        setBuscando(true);
        try {
            const { data } = await axios.get(`/comercial/integracoes/${provider}/produtos-locais?q=${termoBusca}`);
            setResultadosBusca(data.produtos || []);
        } catch (error) {
            console.error("Erro ao buscar", error);
        } finally {
            setBuscando(false);
        }
    };

    const vincularProduto = async (codigoSelecionado) => {
        setSalvando(true);
        try {
            await axios.post(`/comercial/integracoes/${provider}/vincular`, {
                local_id: codigoSelecionado,
                external_id: prod.id_externo
            });
            setLocalId(codigoSelecionado);
            setVinculado(true);
            setResultadosBusca([]);

            onStatusChange(prod.id_externo, true, codigoSelecionado);

        } catch (error) {
            alert(error.response?.data?.message || 'Erro ao vincular produto');
        } finally {
            setSalvando(false);
        }
    };

    const desfazerVinculo = async () => {
        if (!window.confirm(`Tem certeza que deseja remover o vínculo deste produto?`)) return;

        setDesfazendo(true);
        try {
            await axios.delete(`/comercial/integracoes/${provider}/vincular/${prod.id_externo}`);
            setVinculado(false);
            setLocalId('');
            setTermoBusca('');

            onStatusChange(prod.id_externo, false, null);

        } catch (error) {
            alert(error.response?.data?.message || 'Erro ao desfazer vínculo.');
        } finally {
            setDesfazendo(false);
        }
    };

    return (
        <tr>
            <td className="text-center">
                <img
                    src={prod.imagem || 'https://via.placeholder.com/50?text=Sem+Foto'}
                    alt="Foto"
                    width="60" height="60"
                    className="rounded border shadow-sm"
                />
            </td>
            <td>
                <strong style={{ fontSize: '1.1rem' }}>{prod.nome || 'Sem nome'}</strong><br />
                <span className="badge bg-light text-dark border mt-1">
                    SKU: {prod.sku || 'N/A'} | ID: {prod.id_externo}
                </span>
            </td>
            <td className="fw-bold text-success">
                {prod.preco ? parseFloat(prod.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'}
            </td>
            <td>
                {vinculado ? (
                    <div className="alert alert-success p-3 mb-0 d-flex justify-content-between align-items-center shadow-sm">
                        <div>
                            <i className="bi bi-check-circle-fill me-2 fs-5 align-middle"></i>
                            <span className="align-middle">Vinculado ao sist. (Cód: <strong>{localId}</strong>)</span>
                        </div>
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={desfazerVinculo}
                            disabled={desfazendo}
                            title="Desfazer vínculo"
                        >
                            {desfazendo ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-x-circle me-1"></i> Desfazer</>}
                        </button>
                    </div>
                ) : (
                    <div className="position-relative">
                        <form onSubmit={buscarNoSistema} className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Cód. ou Descrição..."
                                value={termoBusca}
                                onChange={(e) => setTermoBusca(e.target.value)}
                            />
                            <button className="btn btn-primary px-3" type="submit" disabled={buscando || salvando}>
                                {buscando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-search me-1"></i> Buscar</>}
                            </button>
                        </form>

                        {resultadosBusca.length > 0 && (
                            <ul className="list-group position-absolute w-100 mt-2 shadow-lg" style={{ zIndex: 1000, maxHeight: '280px', overflowY: 'auto', border: '2px solid #0078d4' }}>
                                <li className="list-group-item bg-light text-muted fw-bold p-2 text-center" style={{ fontSize: '0.85rem' }}>
                                    Selecione o produto correspondente:
                                </li>
                                {resultadosBusca.map(item => (
                                    <li key={item.PRODUTO} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center p-3">
                                        <div className="me-3">
                                            <span className="badge bg-secondary me-2 fs-6">Cód: {item.PRODUTO}</span>
                                            <strong className="text-wrap">{item.DESCRICAO}</strong>
                                        </div>
                                        <button
                                            className="btn btn-success flex-shrink-0"
                                            onClick={() => vincularProduto(item.PRODUTO)}
                                            disabled={salvando}
                                        >
                                            <i className="bi bi-link-45deg me-1 fs-5 align-middle"></i> <span className="align-middle fw-bold">Vincular</span>
                                        </button>
                                    </li>
                                ))}
                                <li className="list-group-item text-center p-2 bg-light">
                                    <button className="btn btn-outline-secondary w-100" onClick={() => setResultadosBusca([])}>Fechar lista</button>
                                </li>
                            </ul>
                        )}
                    </div>
                )}
            </td>
        </tr>
    );
};

// --- COMPONENTE PRINCIPAL ---
const SincronizacaoProdutos = ({ tenant, provider, providerLabel }) => {
    const label = providerLabel || provider;
    const [produtos, setProdutos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [buscou, setBuscou] = useState(false);

    const [buscaExterna, setBuscaExterna] = useState('');
    const [filtroStatus, setFiltroStatus] = useState('todos');

    const buscarProdutos = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(`/comercial/integracoes/${provider}/produtos`);
            setProdutos(response.data.produtos || []);
            setBuscou(true);
        } catch (err) {
            setError(err.response?.data?.message || `Falha ao buscar a lista de produtos da ${label}.`);
        } finally {
            setLoading(false);
        }
    };

    const atualizarStatusProduto = (idExterno, novoStatusVinculado, novoLocalId) => {
        setProdutos(prevProdutos =>
            prevProdutos.map(p =>
                p.id_externo === idExterno
                    ? { ...p, vinculado: novoStatusVinculado, local_id: novoLocalId }
                    : p
            )
        );
    };

    const produtosFiltrados = produtos.filter((prod) => {
        const textoBusca = buscaExterna.toLowerCase();
        const matchBusca =
            (prod.nome && prod.nome.toLowerCase().includes(textoBusca)) ||
            (prod.sku && prod.sku.toLowerCase().includes(textoBusca)) ||
            (prod.id_externo && prod.id_externo.includes(textoBusca));

        let matchStatus = true;
        if (filtroStatus === 'vinculados') matchStatus = prod.vinculado === true;
        if (filtroStatus === 'nao_vinculados') matchStatus = prod.vinculado === false;

        return matchBusca && matchStatus;
    });

    return (
        <div>
            <button
                className="btn btn-powerbi mb-4 px-4 py-2 fs-5 shadow-sm"
                onClick={buscarProdutos}
                disabled={loading}
            >
                <i className="bi bi-cloud-arrow-down-fill me-2"></i>
                {loading ? 'Buscando e cruzando produtos...' : `Buscar Produtos da ${label}`}
                {loading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
            </button>

            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {buscou && produtos.length === 0 && !error && <div className="alert alert-info mt-3">Nenhum produto encontrado.</div>}

            {produtos.length > 0 && (
                <>
                    <div className="row mb-3 bg-light p-3 rounded border">
                        <div className="col-md-8">
                            <label className="form-label text-secondary fw-bold small">Pesquisar na loja virtual</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-search"></i></span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Buscar por nome, SKU ou ID na ${label}...`}
                                    value={buscaExterna}
                                    onChange={(e) => setBuscaExterna(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold small">Status do Vínculo</label>
                            <select
                                className="form-select"
                                value={filtroStatus}
                                onChange={(e) => setFiltroStatus(e.target.value)}
                            >
                                <option value="todos">Todos os Produtos ({produtos.length})</option>
                                <option value="vinculados">Apenas Vinculados</option>
                                <option value="nao_vinculados">Não Vinculados</option>
                            </select>
                        </div>
                    </div>

                    {produtosFiltrados.length === 0 && (
                        <div className="alert alert-warning text-center">
                            Nenhum produto corresponde aos filtros aplicados.
                        </div>
                    )}

                    {produtosFiltrados.length > 0 && (
                        <div className="table-responsive mt-2 pb-5">
                            <table className="table table-hover table-bordered align-middle bg-white">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" width="80" className="text-center">Foto</th>
                                        <th scope="col">Produto na {label}</th>
                                        <th scope="col" width="140">Preço</th>
                                        <th scope="col" width="400">Vínculo no Sistema (PRODUTO)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {produtosFiltrados.map((prod) => (
                                        <LinhaProduto
                                            key={prod.id_externo}
                                            prod={prod}
                                            provider={provider}
                                            onStatusChange={atualizarStatusProduto}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SincronizacaoProdutos;
